import React from 'react';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import SEO from '../components/common/SEO';

const NotFound = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language?.startsWith('ar');
  return (
    <>
      <Helmet>
        <html lang={isArabic ? "ar" : "en"} dir={isArabic ? "rtl" : "ltr"} />
        <title>
          {isArabic ? "الصفحة غير موجودة" : "Page Not Found"}
        </title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <SEO />

      <div className="text-center py-20">
        <h1 className="text-5xl font-bold mb-4" style={{ color: 'var(--text-header)' }}>404</h1>
        <p className="mb-6" style={{ color: 'var(--text-main)' }}>{t('not_found.message')}</p>
        <Link to="/" className="hover:underline font-bold" style={{ color: 'var(--primary)' }}>{t('not_found.go_home')}</Link>
      </div>
    </>
  );
}

export default NotFound;
